import {Injectable, OnDestroy} from '@angular/core';

import {ReplaySubject} from 'rxjs';
import {distinctUntilChanged, skipWhile, takeUntil} from 'rxjs/operators';

import {UserStore} from '@stores/user.store';

import {PosthogWrapperService} from '@services/posthog-wrapper.service';

import * as UU from '@common/utils/dist/utils/user-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PosthogUserReactor implements OnDestroy {
  private _destroyed$ = new ReplaySubject<void>();
  constructor(
    private userStore: UserStore,
    private posthogWrapperService: PosthogWrapperService,
  ) {
    if (U.isEmpty(environment.posthogApiKey)) {
      return;
    }

    this.userStore.state$
      .pipe(
        skipWhile((u) => U.isEmpty(u)),
        distinctUntilChanged((a, b) => a?.userId === b?.userId),
        takeUntil(this._destroyed$),
      )
      .subscribe((user) => {
        if (U.isEmpty(user?.userId)) {
          this.posthogWrapperService.reset();
        } else if (UU.isStudent(user)) {
          this.posthogWrapperService.reset();
          this.posthogWrapperService.stopSessionRecording();
        } else {
          const profileProperties: {[key: string]: string | string[]} = {};
          profileProperties.role = 'teacher';
          profileProperties.licenses = Object.keys(user.curriculums ?? {});
          profileProperties.domain = user.email?.split('@')[1];
          profileProperties.identityProvider =
            user.identityProvider ?? 'notebook';
          this.posthogWrapperService.identify(user.userId, profileProperties);
          this.posthogWrapperService.startSessionRecording();
        }
      });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
